import { render } from "./foroCard.vue?vue&type=template&id=6a6699c0&scoped=true"
import script from "./foroCard.vue?vue&type=script&lang=js"
export * from "./foroCard.vue?vue&type=script&lang=js"

import "./foroCard.vue?vue&type=style&index=0&id=6a6699c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6699c0"]])

export default __exports__